import { getApiUrl } from './configService';
import { authGet, authPost, authPatch, authDelete } from './apiService';

const enc = encodeURIComponent;

/**
 * Public survey calls use plain fetch with credentials omitted, so no session
 * cookie or auth token ever reaches the anonymous survey endpoints.
 */
const publicRequest = async (path, init = {}) => {
  const base = await getApiUrl();
  const res = await fetch(`${base}${path}`, {
    ...init,
    credentials: 'omit',
    headers: { 'Content-Type': 'application/json' },
  });
  const body = await res.json().catch(() => ({}));
  if (!res.ok) {
    const error = new Error(body.message || `Request failed (${res.status})`);
    error.status = res.status;
    throw error;
  }
  return body.data;
};

/** { stream, open, round: { id, sprintName, questions } | null, scale, retroMaxLength } */
export const getCurrentSurvey = (stream) => publicRequest(`/api/survey/${enc(stream)}/current`);

/** retro: { start, stop, continue } free text; empty boxes are fine. */
export const submitSurvey = (stream, roundId, answers, retro) =>
  publicRequest(`/api/survey/${enc(stream)}/responses`, {
    method: 'POST',
    body: JSON.stringify({ roundId, answers, retro }),
  });

const ADMIN = '/api/admin/survey';

export const startSurveyRound = (stream, sprintName) => authPost(`${ADMIN}/rounds`, { stream, sprintName });
export const reopenSurveyRound = (id) => authPatch(`${ADMIN}/rounds/${enc(id)}/open`, {});
export const closeSurveyRound = (id) => authPatch(`${ADMIN}/rounds/${enc(id)}/close`, {});
export const deleteSurveyRound = (id) => authDelete(`${ADMIN}/rounds/${enc(id)}`);

const fresh = { useCache: false };

/** { responseCount, hidden, minResponses, start: [], stop: [], continue: [], themes: { responseCount, start: [{ theme, count }], … } | null } */
export const getSurveyRetro = async (id) => (await authGet(`${ADMIN}/rounds/${enc(id)}/retro`, null, 'json', fresh)).data;

/** { team, rounds: [{ id, sprintName, status, responseCount, openedAt, openedBy, summary, retro }] }, newest first */
export const getTeamSurveyHistory = async (team) => (await authGet(`${ADMIN}/teams/${enc(team)}/history`, null, 'json', fresh)).data;

/** Adds one line as a tracked retro action on the team's check-in for the sprint. */
export const trackRetroAction = (sprint, team, text) =>
  authPost(`/api/sprint-health/checkin/${enc(sprint)}/${enc(team)}/retro-actions`, { text });

/** Groups the round's Start / Stop / Continue text into themes with AI; returns the stored themes. */
export const generateRetroThemes = async (id) => (await authPost(`${ADMIN}/rounds/${enc(id)}/themes`, {})).data;
